<script setup lang="ts">
import VButton from '@components/buttons/VButton/VButton.vue';
import VDialog from '@components/dialogs/VDialog/VDialog.vue';
import { useCopyToClipboard } from '@modules/core/composables/copy';
import { TRANSLATION_GROUP_INTERFACE_CONFIRM_OPEN_LINK } from '@modules/i18n/constants';

import type { IConfirmOpenLinkEmits, IConfirmOpenLinkProps } from './types';

defineProps<IConfirmOpenLinkProps>();
const emit = defineEmits<IConfirmOpenLinkEmits>();

const visible = defineModel<boolean>('visible');

const { copyToClipboard } = useCopyToClipboard();

function onHideConfirmDialog() {
  visible.value = false;
  emit('hide');
}
</script>

<template>
  <VDialog
    :visible="visible"
    :title="$getTranslation(TRANSLATION_GROUP_INTERFACE_CONFIRM_OPEN_LINK, 'CONFIRM_OPEN_LINK.TITLE')"
    @hide="onHideConfirmDialog"
  >
    <div class="input-max-width word-break">
      <slot>
        {{ $getTranslation(TRANSLATION_GROUP_INTERFACE_CONFIRM_OPEN_LINK, 'CONFIRM_OPEN_LINK.MESSAGE', { link }) }}
      </slot>
    </div>
    <template #footer>
      <div
        v-if="link"
        class="flex gap-2"
      >
        <VButton
          :label="$getTranslation(TRANSLATION_GROUP_INTERFACE_CONFIRM_OPEN_LINK, 'CONFIRM_OPEN_LINK.COPY')"
          outlined
          @click="copyToClipboard(link)"
        />
        <VButton
          :label="$getTranslation(TRANSLATION_GROUP_INTERFACE_CONFIRM_OPEN_LINK, 'CONFIRM_OPEN_LINK.OPEN')"
          :href="link"
          target="_blank"
        />
      </div>
    </template>
  </VDialog>
</template>
